import React from "react";
import { Box } from "@mui/material";
import TranslationWrapper from "../../../../../components/TranslationWrapper/TranslationWrapper";
import FormSwitchTC from "../../../../../components/Forms/FormSwitchTC";
import { useWatch } from "react-hook-form";

export default function AutoSyncSwitch() {
  const autoSyncImportBoomi = useWatch({ name: "menu_auto_sync" });
  const scheduledTaskId = autoSyncImportBoomi?.id;

  return (
    <FormSwitchTC
      label={
        <Box component={"span"}>
          <TranslationWrapper tDefault={"Auto sync"} tKey={"vestigingen.form.pos.label.autosync"} />{" "}
          {scheduledTaskId ? <a href={`/manager/scheduledTasks/${scheduledTaskId}/edit`}>Edit me</a> : null}
        </Box>
      }
      name={"menu_auto_sync__active"}
    />
  );
}
